export default __webpack_public_path__ + "static/media/appworkco.6645ab47.png";